// import React, { useState, useRef, useEffect } from "react";
// import { createPortal } from "react-dom";
// import { saveComment } from "../context/CommonContex";

// const HoverPO = ({
//   comments,
//   position = "top",
//   children,
//   onDeleteComment,
//   onResolveThread,
//   onAddComment,
//   orderLineId
// }) => {
//   const [visible, setVisible] = useState(false);
//   const [newComment, setNewComment] = useState("");
//   const [newCommentStatus, setNewCommentStatus] = useState("pending");
//   const [showAddForm, setShowAddForm] = useState(false);
//   //const [orderLineId,setOrderLineId] = useState(orderLineId);
//   const [mapComment,setMapComment] = useState(comments);

//   const wrapperRef = useRef(null);
//   const triggerRef = useRef(null);
//   const popupRef = useRef(null);
//   const [popupPos, setPopupPos] = useState({ top: 0, left: 0 });

//   // Outside click
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         wrapperRef.current &&
//         !wrapperRef.current.contains(event.target) &&
//         popupRef.current &&
//         !popupRef.current.contains(event.target)
//       ) {
//         setVisible(false);
//         setShowAddForm(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Position popup
//   useEffect(() => {
//     if (visible && triggerRef.current) {
//       const rect = triggerRef.current.getBoundingClientRect();
//       setPopupPos({
//         top: rect.bottom + window.scrollY + 8,
//         left: rect.left + window.scrollX - 260,
//       });
//     }
//   }, [visible]);

//   const handleDeleteComment = (commentId) => {
//     if (
//       onDeleteComment &&
//       window.confirm("Are you sure you want to delete this comment?")
//     ) {
//       onDeleteComment(commentId);
//     }
//   };

//   const handleResolveThread = () => {
//     if (
//       onResolveThread &&
//       window.confirm("Are you sure you want to resolve this thread?")
//     ) {
//       onResolveThread();
//       setVisible(false);
//     }
//   };

//   const handleAddComment = () => {
//     if (newComment.trim() && onAddComment) {
//       onAddComment(newComment, newCommentStatus);
//       setNewComment("");
//       setNewCommentStatus("pending");
//       setShowAddForm(false);
//     }
//   };

//   const getStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case "resolved":
//         return "#28a745";
//       case "pending":
//         return "#ffc107";
//       case "urgent":
//         return "#dc3545";
//       default:
//         return "#6c757d";
//     }
//   };

//   const [formData, setFormData] = useState({
//           comment: "",
//           flowName: "Order",
//           status: "",
//           orderLineId: ""
//   });
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };
//   const handleSubmit = async (e) => {
//      e.preventDefault();
//      debugger
//       try {
//            formData.flowName = "Order";
//            formData.orderLineId = orderLineId;
//            const comment = await saveComment(formData);
//            setFormData({
//                   comment: "",
//                   flowName: "Order",
//                   status: "",
//                   orderLineId: ""
//           })
//            setMapComment(prev => [comment,...prev]);
//            setShowAddForm(false);
//           } catch (error) {
//               console.error("Error submitting form:", error);
//           }
//   };

//   return (
//     <div ref={wrapperRef} className="tooltip-wrapper">
//       {React.cloneElement(children, {
//         ref: triggerRef,
//         onClick: () => setVisible((v) => !v),
//         style: { ...children.props.style, position: "relative" },
//       })}

//       {/* Badge */}
//       {mapComment.length > 0 && (
//         <div
//           className="comment-badge"
//           style={{
//             backgroundColor: (() => {
//               const unresolvedCount = mapComment.filter((c) => !c.resolved).length;
//               const urgentCount = mapComment.filter(
//                 (c) => c.status === "urgent" && !c.resolved
//               ).length;
//               if (urgentCount > 0) return "#dc3545";
//               if (unresolvedCount > 0) return "#ffc107";
//               return "#28a745";
//             })(),
//           }}
//         >
//           {mapComment.filter((c) => !c.resolved).length || mapComment.length}
//         </div>
//       )}

//       {visible &&
//         createPortal(
//           <div
//             className={`tooltip-box tooltip-${position}`}
//             style={{ top: popupPos.top, left: popupPos.left }}
//             ref={popupRef}
//           >
//             {/* Header */}
//             <div className="tooltip-header">
//               <h6>Comments ({mapComment.length})</h6>
//               <div className="actions">
//                 <button
//                   className="btn btn-primary"
//                   onClick={() => setShowAddForm(!showAddForm)}
//                 >
//                   +
//                   Add
//                 </button>
//                 {mapComment.length > 0 && (
//                   <button className="btn btn-success" onClick={handleResolveThread}>
//                     ✓ Resolve
//                   </button>
//                 )}
//               </div>
//             </div>

//             {/* Add Comment */}
//             {showAddForm && (
//               <div className="add-comment">
//                 <textarea
//                   value={formData?.comment ?? ""}   // ✅ safer
//                   name="comment"
//                   onChange={(e)=> handleChange(e)}
//                   placeholder="Add a new comment..."
//                 />

//                 <div className="form-actions">
//                   {/* <select
//                     value={newCommentStatus}
//                     onChange={(e) => setNewCommentStatus(e.target.value)}
//                   >
//                     <option value="pending">Pending</option>
//                     <option value="urgent">Urgent</option>
//                     <option value="resolved">Resolved</option>
//                   </select> */}
//                   <button
//                     className="btn btn-primary"
//                     disabled={!formData?.comment?.trim()}
//                     onClick={handleSubmit}
//                   >
//                     Save
//                   </button>

//                   <button
//                     className="btn btn-secondary"
//                     onClick={() => {
//                       setShowAddForm(false);
//                       setNewComment("");
//                       setNewCommentStatus("pending");
//                     }}
//                   >
//                     Cancel
//                   </button>
//                 </div>
//               </div>
//             )}

//             {/* Comment List */}
//             {mapComment.length === 0 ? (
//               <div className="no-comments">
//                 <p>No comments yet.</p>
//                 <p>Click "Add" to start a conversation</p>
//               </div>
//             ) : (
//               <div className="comments-list">
//                 {mapComment.map((comment, index) => (
//                   <div
//                     key={comment.id || index}
//                     className={`comment-card ${comment.resolved ? "resolved" : ""}`}
//                   >
//                     <div className="comment-header">
//                       <div className="comment-user">
//                         <div className="user-avatar">
//                           {(comment.lastEditedBy || "U").charAt(0).toUpperCase()}
//                         </div>
//                         <div>
//                           <strong
//                             className={`user-name ${comment.resolved ? "resolved" : ""}`}
//                           >
//                             {comment.lastEditedBy || "Unknown User"}
//                           </strong>
//                           <div className="comment-meta">
//                             <span>
//                               {comment.dateStr} {comment.timeStr}
//                             </span>
//                             {comment.status && (
//                               <span
//                                 className="comment-status"
//                                 style={{ backgroundColor: getStatusColor(comment.status) }}
//                               >
//                                 {comment.status}
//                               </span>
//                             )}
//                             {comment.resolved && (
//                               <span
//                                 className="comment-status"
//                                 style={{ backgroundColor: "#28a745" }}
//                               >
//                                 Resolved
//                               </span>
//                             )}
//                           </div>
//                         </div>
//                       </div>

//                       <div>
//                         {onDeleteComment && (
//                           <button
//                             className="btn-icon"
//                             title="Delete comment"
//                             onClick={() =>
//                               handleDeleteComment(comment.id || index)
//                             }
//                           >
//                             🗑
//                           </button>
//                         )}
//                         {!comment.resolved && onResolveThread && (
//                           <button
//                             className="btn-icon"
//                             title="Mark as resolved"
//                             onClick={() => onResolveThread(comment.id || index)}
//                           >
//                             ✓
//                           </button>
//                         )}
//                       </div>
//                     </div>
//                     <div className={`comment-body ${comment.resolved ? "resolved" : ""}`}>
//                       {comment.comment}
//                     </div>
//                     {comment.replyTo && (
//                       <div className="reply-indicator">
//                         ↳ Reply to {comment.replyTo}
//                       </div>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             )}

//             {/* Footer */}
//             {mapComment.length > 0 && (
//               <div className="tooltip-footer">
//                 {mapComment.filter((c) => c.resolved).length} of {mapComment.length} comments resolved
//               </div>
//             )}
//           </div>,
//           document.body
//         )}
//     </div>
//   );
// };

// export default HoverPO;
import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { deleteComment, deletePOComment, deleteQuoteComment, saveComment, savePOComment, saveQuoteComment, getUsers } from "../context/CommonContex";
import InitialAvatar from './InitialAvatar';
import EmojiPickerButton from './Common/EmojiPickerButton';
import './Common/PresenceBar.css';
import { formatThreadTitle, getCommentThreadKey, useCommentDock } from '../context/CommentDockContext';
import { extractCommentText, normalizeComment } from '../utils/commentText';
import MentionSuggestions from './comments/MentionSuggestions';

// helper to escape regex special chars
const escapeRegex = (s) => {
  if (!s) return '';
  return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
};

// Helper function to sort comments by date/time in descending order (most recent first)
const sortCommentsByDate = (comments) => {
  if (!Array.isArray(comments) || comments.length === 0) return comments;
  return [...comments].sort((a, b) => {
    // Try to parse date and time from comment objects
    const dateA = a.dateStr && a.timeStr ? new Date(`${a.dateStr} ${a.timeStr}`) : 
                 a.createdAt ? new Date(a.createdAt) : 
                 a.date ? new Date(a.date) : new Date(0);
    const dateB = b.dateStr && b.timeStr ? new Date(`${b.dateStr} ${b.timeStr}`) : 
                 b.createdAt ? new Date(b.createdAt) : 
                 b.date ? new Date(b.date) : new Date(0);
    // Return descending order (most recent first)
    return dateB - dateA;
  });
};

const HoverPO = ({
  comments,
  position = "top",
  children,
  onDeleteComment,
  onResolveThread,
  onAddComment,
  orderLineId,
  poLineId,
  quoteId,
  orderNumber,
  customerName,
  customerId,
  lineInfo,
  threadTitle,
  sourcePage = "orders",
  /** Live presence: told whenever this notes popup opens or closes, so the grid
   *  can show "X is in the notes" on the row without it being expanded. */
  onVisibleChange,
}) => {
  const [visible, setVisible] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [newCommentStatus, setNewCommentStatus] = useState("pending");
  const [showAddForm, setShowAddForm] = useState(false);
  //const [orderLineId,setOrderLineId] = useState(orderLineId);
  const [mapComment,setMapComment] = useState(() => sortCommentsByDate(comments || []));

  // Keep internal comment list in sync when parent passes new comments
  useEffect(() => {
    setMapComment(sortCommentsByDate(comments || []));
  }, [comments]);

  // Tell the parent when the popup opens/closes so it can claim or release the
  // presence cell for these notes. Kept in a ref so a new inline callback on
  // every parent render does not re-announce focus.
  const visibleChangeRef = useRef(onVisibleChange);
  visibleChangeRef.current = onVisibleChange;
  const dock = useCommentDock();
  const dockRef = useRef(dock);
  dockRef.current = dock;
  const threadKey = getCommentThreadKey({ orderLineId, quoteId, poLineId });
  const dockThreadOpen = !!threadKey && !!dock?.isThreadOpen?.(threadKey);
  useEffect(() => {
    if (dock?.isThreadOpen?.(threadKey) && !visible) return;
    visibleChangeRef.current?.(visible);
  }, [visible]);
  // The dock window can close or minimize without this row's popup state changing.
  useEffect(() => {
    if (!threadKey) return undefined;
    visibleChangeRef.current?.(dockThreadOpen);
    return undefined;
  }, [dockThreadOpen, threadKey]);
  // A row that scrolls out of the grid unmounts with the popup still open -
  // release the cell rather than leaving a ghost avatar on it.
  useEffect(() => () => {
    if (dock?.isThreadOpen?.(threadKey)) return;
    visibleChangeRef.current?.(false);
  }, []);

  const wrapperRef = useRef(null);
  const triggerRef = useRef(null);
  const popupRef = useRef(null);
  const [popupPos, setPopupPos] = useState({ top: -9999, left: -9999 });
  const [isPositioned, setIsPositioned] = useState(false);

  useEffect(() => {
    const currentDock = dockRef.current;
    if (!currentDock || !threadKey) return;
    currentDock.registerHandlers(threadKey, {
      onAddComment,
      onDeleteComment,
      onResolveThread,
      onVisibleChange: (isVisible) => visibleChangeRef.current?.(isVisible),
    });
    if (currentDock.isThreadOpen?.(threadKey)) {
      visibleChangeRef.current?.(true);
    }
  }, [threadKey, onAddComment, onDeleteComment, onResolveThread]);

  useEffect(() => {
    const currentDock = dockRef.current;
    if (!currentDock || !threadKey) return;
    if (!currentDock.isThreadOpen?.(threadKey)) return;
    currentDock.updateThreadComments?.(
      threadKey,
      Array.isArray(mapComment) ? mapComment.map(normalizeComment) : []
    );
  }, [threadKey, mapComment]);

  const openPersistentThread = () => {
    if (!dock?.openThread || !threadKey) return false;
    dock.openThread({
      key: threadKey,
      expand: true,
      orderLineId,
      quoteId,
      poLineId,
      sourcePage,
      title: threadTitle || formatThreadTitle({ orderNumber, quoteId, poLineId, orderLineId }),
      subtitle: customerName || '',
      lineInfo: lineInfo || '',
      orderNumber,
      customerId,
      comments: mapComment,
      onAddComment,
      onDeleteComment,
      onResolveThread,
      onVisibleChange: (isVisible) => visibleChangeRef.current?.(isVisible),
    });
    visibleChangeRef.current?.(true);
    return true;
  };

  // Outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        popupRef.current &&
        !popupRef.current.contains(event.target)
      ) {
        setVisible(false);
        setShowAddForm(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close popup when scrolling occurs (either window or any scrollable ancestor)
  useEffect(() => {
    if (!visible) return;

    const handleScrollClose = () => {
      setVisible(false);
      setShowAddForm(false);
    };

    // always listen to window scroll
    window.addEventListener('scroll', handleScrollClose, { passive: true });

    // also attach to any scrollable ancestors so internal scrolls close it too
    const addedElements = [];
    try {
      let el = wrapperRef.current ? wrapperRef.current.parentElement : null;
      while (el) {
        const style = window.getComputedStyle(el);
        const overflow = (style.overflow + style.overflowY + style.overflowX).toLowerCase();
        if (overflow.includes('auto') || overflow.includes('scroll')) {
          el.addEventListener('scroll', handleScrollClose, { passive: true });
          addedElements.push(el);
        }
        el = el.parentElement;
      }
    } catch (e) {
      // ignore
    }

    return () => {
      window.removeEventListener('scroll', handleScrollClose);
      addedElements.forEach(a => a.removeEventListener('scroll', handleScrollClose));
    };
  }, [visible]);

  // cleanup suggestion timeout on unmount
  useEffect(() => {
    return () => {
      if (suggestionTimeoutRef.current) clearTimeout(suggestionTimeoutRef.current);
    };
  }, []);

  // Position popup - precise positioning
  useEffect(() => {
    if (visible && triggerRef.current) {
      setIsPositioned(false); // Reset positioning flag
      
      const calculatePosition = () => {
        try {
          const buttonRect = triggerRef.current.getBoundingClientRect();
          const popupWidth = 350;
          const popupHeight = 300;
          
          // Get the exact button position
          const buttonLeft = buttonRect.left;
          const buttonTop = buttonRect.top;
          const buttonBottom = buttonRect.bottom;
          const buttonRight = buttonRect.right;
          
          // Calculate initial position - directly below the button
          let left = buttonLeft;
          let top = buttonBottom + 5; // Small gap below button
          
          // Adjust horizontal position to prevent overflow
          if (left + popupWidth > window.innerWidth) {
            left = buttonRight - popupWidth;
          }
          
          // Adjust vertical position if it would go off screen
          if (top + popupHeight > window.innerHeight) {
            top = buttonTop - popupHeight - 5; // Above the button
          }
          
          // Ensure minimum margins
          if (left < 10) left = 10;
          if (top < 10) top = 10;
          
          setPopupPos({ 
            top: Math.round(top), 
            left: Math.round(left) 
          });
          
          // Mark as positioned after calculation
          setIsPositioned(true);
        } catch (error) {
          console.error('Position calculation error:', error);
          setIsPositioned(true); // Still show even if error
        }
      };

      // Calculate position with a small delay to ensure DOM is ready
      const timeoutId = setTimeout(calculatePosition, 10);
      
      return () => {
        clearTimeout(timeoutId);
        setIsPositioned(false);
      };
    } else {
      setIsPositioned(false);
    }
  }, [visible]);

  const handleDeleteComment = (commentId) => {
    if (
      onDeleteComment &&
      window.confirm("Are you sure you want to delete this comment?")
    ) {
      onDeleteComment(commentId);
    }
  };

  const handleResolveThread = () => {
    if (
      onResolveThread &&
      window.confirm("Are you sure you want to resolve this thread?")
    ) {
      onResolveThread();
      setVisible(false);
    }
  };

  const handleAddComment = () => {
    if (newComment.trim() && onAddComment) {
      onAddComment(newComment, newCommentStatus);
      setNewComment("");
      setNewCommentStatus("pending");
      setShowAddForm(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "resolved":
        return "#28a745";
      case "pending":
        return "#ffc107";
      case "urgent":
        return "#dc3545";
      default:
        return "#6c757d";
    }
  };

  const [formData, setFormData] = useState({
          comment: "",
          flowName: "Order",
          status: "",
      orderLineId: "",
      poLineId: ""
  });
    const [mentions, setMentions] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const commentRef = useRef(null);
    const suggestionTimeoutRef = useRef(null);
    const sendingRef = useRef(false);
    const [sending, setSending] = useState(false);
  const handleChange = (e) => {
    const { name, value, selectionStart } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    // detect mention token before caret
    const pos = selectionStart || value.length;
    const lastAt = value.lastIndexOf('@', pos - 1);
    if (lastAt >= 0) {
      // ensure @ is start or preceded by whitespace
      const before = value[lastAt - 1];
      if (!before || /\s/.test(before)) {
        const token = value.slice(lastAt + 1, pos);
        if (token.length >= 2) {
          // debounce search
          if (suggestionTimeoutRef.current) clearTimeout(suggestionTimeoutRef.current);
          suggestionTimeoutRef.current = setTimeout(async () => {
            try {
              const users = await getUsers(token);
              // expect users as array of { username, displayName, email }
              setSuggestions(users || []);
              setShowSuggestions(Array.isArray(users) && users.length > 0);
            } catch (err) {
              console.error('Error fetching user suggestions', err);
              setSuggestions([]);
              setShowSuggestions(false);
            }
          }, 250);
          return;
        }
      }
    }

    // otherwise hide suggestions
    setShowSuggestions(false);
    if (suggestionTimeoutRef.current) {
      clearTimeout(suggestionTimeoutRef.current);
      suggestionTimeoutRef.current = null;
    }

    // Keep only mentions that still appear in the text. This prevents partial tokens
    // from being kept (and from being sent) if the user erases them.
    try {
      const text = value || '';
      setMentions(prev => {
        if (!prev || prev.length === 0) return prev || [];
        return prev.filter(m => {
          if (!m || !m.username) return false;
          const re = new RegExp(`@${escapeRegex(m.username)}(\\s|$)`, 'g');
          return re.test(text);
        });
      });
    } catch (err) {
      // ignore parse errors
    }
  };
  const handleSelectSuggestion = (user) => {
    // insert @username into comment replacing current token
    const textarea = commentRef.current;
    if (!textarea) return;
    const { selectionStart } = textarea;
    const val = formData.comment || '';
    const lastAt = val.lastIndexOf('@', selectionStart - 1);
    if (lastAt < 0) return;
    const before = val.slice(0, lastAt + 1);
    const after = val.slice(selectionStart);
    const mentionText = user.username || user.email || user.name;
    const insert = `${mentionText} `;
    const newComment = before + insert + after;
    setFormData(prev => ({ ...prev, comment: newComment }));
    // Add the selected user to mentions with email if available. Use email for backend.
    const userEmail = user.email || user.username || '';
    setMentions(prev => {
      const exists = (prev || []).some(m => (m.email && userEmail && m.email === userEmail) || m.username === mentionText);
      if (exists) return prev;
      return [...(prev || []), { username: mentionText, email: userEmail, displayName: user.displayName || mentionText }];
    });
    setShowSuggestions(false);
    setSuggestions([]);
    // move caret after inserted text
    setTimeout(() => {
      const pos = (before + insert).length;
      textarea.focus();
      textarea.setSelectionRange(pos, pos);
    }, 0);
  };

  const insertEmojiAtCursor = (emoji) => {
    const textarea = commentRef.current;
    const val = formData.comment ?? '';
    const start = textarea ? textarea.selectionStart : val.length;
    const end = textarea ? textarea.selectionEnd : val.length;
    const before = val.slice(0, start);
    const after = val.slice(end);
    const newComment = before + emoji + after;
    setFormData(prev => ({ ...prev, comment: newComment }));
    if (textarea) {
      setTimeout(() => {
        const pos = (before + emoji).length;
        textarea.focus();
        textarea.setSelectionRange(pos, pos);
      }, 0);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (sendingRef.current || !formData?.comment?.trim()) return;
    sendingRef.current = true;
    setSending(true);
    try {
      const payload = { ...formData };
      payload.flowName = poLineId ? 'Purchase Order' : 'Order';
      payload.poLineId = poLineId;
      payload.orderLineId = orderLineId;
      payload.quoteId = quoteId;

      // Send only selected mentions' emails to backend
      payload.mentions = Array.from(new Set((mentions || []).map(m => m.email).filter(Boolean)));

      // Optimistic update: show the comment immediately in UI while saving.
      const tempId = `tmp-${Date.now()}`;
      const now = new Date();
      const localUser = localStorage.getItem('userEmail') || 'You';
      const optimistic = {
        id: tempId,
        comment: payload.comment,
        lastEditedBy: localUser,
        dateStr: now.toLocaleDateString(),
        timeStr: now.toLocaleTimeString(),
        status: payload.status || '',
        resolved: false,
      };

      setMapComment(prev => sortCommentsByDate([optimistic, ...prev]));

      let serverComment = null;
      try {
        if (poLineId) serverComment = await savePOComment(payload);
        else if (orderLineId) serverComment = await saveComment(payload);
        else if (quoteId) serverComment = await saveQuoteComment(payload);
      } catch (err) {
        console.error('Error saving comment to server:', err);
        // remove optimistic comment on failure
        setMapComment(prev => prev.filter(c => c.id !== tempId));
        throw err;
      }

      // Tell the page only after the comment is saved, so other users are notified once.
      const savedComment = serverComment && typeof serverComment === 'object'
        && (serverComment.comment || serverComment.id)
        ? serverComment
        : optimistic;
      try {
        if (typeof onAddComment === 'function') {
          onAddComment(savedComment, payload.status || 'pending');
        }
      } catch (err) {
        // ignore parent update errors
      }

      // Save succeeded. Empty the box now, before Teams or anything else.
      setFormData({ comment: '', flowName: 'Order', status: '', orderLineId: '', poLineId: '' });
      setMentions([]);
      setSuggestions([]);
      setShowAddForm(false);

      // replace optimistic comment with server response (if provided), otherwise keep optimistic
      if (serverComment) {
        setMapComment(prev => {
          const replaced = prev.map(c => (c.id === tempId ? serverComment : c));
          // if server returned the created comment not as an object but as an array or other shape,
          // try to normalize: if serverComment has comment property use it, else keep optimistic
          return sortCommentsByDate(replaced);
        });
      }

      // Send Teams notification
      try {
        const { sendTeamsNotification } = await import('../context/CommonContex');
        await sendTeamsNotification({
          comment: payload.comment,
          addedBy: localUser,
          orderNumber: orderNumber || 'N/A',
          orderLineId: orderLineId || poLineId,
          poLineId: poLineId || null,
          customerName: customerName || null,
          customerId: customerId || null
        });
      } catch (err) {
        console.warn('Teams notification failed, but comment was saved:', err);
        // Don't fail the submission if Teams notification fails
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      sendingRef.current = false;
      setSending(false);
    }
  };

  const removeMention = (mention) => {
    // mention can be email or username; prefer username removal from text
    const username = mention.username || (mention.email ? (mention.email.split('@')[0]) : mention);
    setMentions(prev => (prev || []).filter(m => {
      if (mention.email && m.email) return m.email !== mention.email;
      return m.username !== username;
    }));

    // remove occurrences of @username from the comment text
    setFormData(prev => {
      const text = prev.comment || '';
      const re = new RegExp(`@${escapeRegex(username)}(\\s)?`, 'g');
      const updated = text.replace(re, '');
      return { ...prev, comment: updated.trim().replace(/\s{2,}/g, ' ') };
    });
  }
  const handleDelete = async (commentId) =>{

    let afterDomments ;
    if(poLineId)
      afterDomments =  await deletePOComment(commentId,poLineId);
    else if(orderLineId)
      afterDomments =  await deleteComment(commentId,orderLineId);
    else if(quoteId){
      afterDomments =  await deleteQuoteComment(commentId,quoteId);
    }
    if(afterDomments)
        setMapComment(sortCommentsByDate(afterDomments));
    else
        setMapComment([]);
  }
  return (
    <div ref={wrapperRef} className="tooltip-wrapper">
      {React.cloneElement(children, {
        ref: triggerRef,
        onClick: (e) => {
          if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
          if (typeof children.props.onClick === 'function') children.props.onClick(e);
          if (openPersistentThread()) return;
          setVisible((v) => !v);
        },
        title: children.props.title || "Expand notes",
        style: { ...children.props.style, position: "relative" },
      })}

      {/* Badge */}
      {mapComment.length > 0 && (
        <div
          className="comment-badge"
          style={{
            backgroundColor: (() => {
              const unresolvedCount = mapComment.filter((c) => !c.resolved).length;
              const urgentCount = mapComment.filter(
                (c) => c.status === "urgent" && !c.resolved
              ).length;
              if (urgentCount > 0) return "#dc3545";
              if (unresolvedCount > 0) return "#ffc107";
              return "#28a745";
            })(),
          }}
        >
          {mapComment.filter((c) => !c.resolved).length || mapComment.length}
        </div>
      )}

      {visible && isPositioned &&
        createPortal(
          <div
            className={`tooltip-box tooltip-${position}`}
            style={{ top: popupPos.top, left: popupPos.left }}
            ref={popupRef}
          >
            {/* Header */}
            <div className="tooltip-header">
              <h6>Comments ({mapComment.length})</h6>
              <div className="actions">
                <button
                  className="btn btn-primary"
                  title="Add a note"
                  onClick={() => setShowAddForm(!showAddForm)}
                >
                  +
                  Add
                </button>
                {mapComment.length > 0 && (
                  <button
                    className="btn btn-success"
                    onClick={handleResolveThread}
                  >
                    ✓ Resolve
                  </button>
                )}
              </div>
            </div>

            {/* Add Comment */}
            {showAddForm && (
              <div className="add-comment" style={{ position: 'relative' }}>
                <div style={{ position: 'relative', width: '100%' }}>
                  <textarea
                    ref={commentRef}
                    value={formData?.comment ?? ""}
                    name="comment"
                    onChange={(e)=> handleChange(e)}
                    placeholder="Add a new comment..."
                    rows={3}
                    style={{ width: '100%', resize: 'vertical', paddingRight: 36, fontSize: '1.5rem', lineHeight: 1.5 }}
                  />
                  <span style={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}>
                    <EmojiPickerButton onSelect={insertEmojiAtCursor} title="Add emoji" />
                  </span>
                  {showSuggestions && suggestions && suggestions.length > 0 && (
                    <MentionSuggestions users={suggestions} onSelect={handleSelectSuggestion} inline />
                  )}
                </div>

                {mentions && mentions.length > 0 && (
                  <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {mentions.map((m, idx) => (
                      <div key={idx} style={{ display: 'inline-flex', alignItems: 'center', padding: '4px 8px', background: '#eef2ff', borderRadius: 16, border: '1px solid #d0d7ff' }}>
                        <span style={{ marginRight: 8, fontSize: 12 }}>{m.displayName || (m.email ? m.email.split('@')[0] : m.username)}</span>
                        <button type="button" onClick={() => removeMention(m)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 0, lineHeight: 1 }} aria-label={`Remove ${m.displayName || m.username}`}>
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                <div className="form-actions">
                  {/* <select
                    value={newCommentStatus}
                    onChange={(e) => setNewCommentStatus(e.target.value)}
                  >
                    <option value="pending">Pending</option>
                    <option value="urgent">Urgent</option>
                    <option value="resolved">Resolved</option>
                  </select> */}
                  <button
                    className="btn btn-primary"
                    disabled={sending || !formData?.comment?.trim()}
                    onClick={handleSubmit}
                  >
                    Save
                  </button>

                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowAddForm(false);
                      setNewComment("");
                      setNewCommentStatus("pending");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            {/* Comment List */}
            {mapComment.length === 0 ? (
              <div className="no-comments">
                <p>No comments yet.</p>
                <p>Click "Add" to start a conversation</p>
              </div>
            ) : (
              <div className="comments-list">
                {mapComment.map((comment, index) => (
                  <div
                    key={comment.id || index}
                    className={`comment-card ${comment.resolved ? "resolved" : ""}`}
                  >
                    <div className="comment-header">
                      <div className="comment-user">
                        <InitialAvatar name={comment.lastEditedBy || 'U'} />
                        <div>
                          {/* <strong
                            className={`user-name ${comment.resolved ? "resolved" : ""}`}
                          >
                            {comment.lastEditedBy || "Unknown User"}
                          </strong> */}

                          <strong className={`user-name ${comment.resolved ? "resolved" : ""}`}>
                            {(comment.lastEditedBy || "Unknown User").split('@')[0]}
                          </strong>

                          <div className="comment-meta">
                            <span>
                              {comment.dateStr} {comment.timeStr}
                            </span>
                            {comment.status && comment.status.toString().toLowerCase() !== "pending" && (
                              <span
                                className="comment-status"
                                style={{ backgroundColor: getStatusColor(comment.status) }}
                              >
                                {comment.status}
                              </span>
                            )}
                            {comment.resolved && (
                              <span
                                className="comment-status"
                                style={{ backgroundColor: "#28a745" }}
                              >
                                Resolved
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div>
                        {/* {onDeleteComment && ( */}
                          <button
                            className="btn-icon"
                            title="Delete comment"
                            onClick={() =>
                              handleDelete(comment.id)
                            }
                          >
                            🗑
                          </button>
                        {/* )} */}
                        {!comment.resolved && onResolveThread && (
                          <button
                            className="btn-icon"
                            title="Mark as resolved"
                            onClick={() => onResolveThread(comment.id || index)}
                          >
                            ✓
                          </button>
                        )}
                      </div>
                    </div>
                    <div className={`comment-body ${comment.resolved ? "resolved" : ""}`}>
                      {extractCommentText(comment)}
                    </div>
                    {comment.replyTo && (
                      <div className="reply-indicator">
                        ↳ Reply to {comment.replyTo}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* Footer */}
            {mapComment.length > 0 && (
              <div className="tooltip-footer">
                {mapComment.filter((c) => c.resolved).length} of {mapComment.length} comments resolved
              </div>
            )}
          </div>,
          document.body
        )}
    </div>
  );
};

export default HoverPO;
